import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPackage = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-package-icon lucide-package",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 22V12" }),
		/* @__PURE__ */ _jsx("polyline", { points: "3.29 7 12 12 20.71 7" }),
		/* @__PURE__ */ _jsx("path", { d: "m7.5 4.27 9 5.15" })
	]
});
export default SvgPackage;
